import { Component, DoCheck, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { interval, Observable, queue, Subject } from 'rxjs';
import { deepCheckObject, register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { gridItem } from 'src/app/models';
import { WidgetBaseComponent } from '../../widget-base.component';
import { widgetType } from 'src/app/enums';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { Store } from '@ngrx/store';
import { getDashboardsConfigState, State } from 'src/app/dashboards/state';
import { take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-calls',
    templateUrl: './calls.component.html',
    styleUrls: ['./calls.component.scss'],
    standalone: false
})
@register("Calls")
export class CallsComponent implements OnInit, OnDestroy, DoCheck, WidgetBaseComponent {
  @Input() public isInWizard: boolean;
  @Output() public restrictedDataEvent = new EventEmitter<boolean>();

  _gridItem: gridItem;
  get gridItem(): gridItem {
    return this._gridItem;
  }
  @Input() set gridItem(value: any) {
    this._gridItem = value;
    setTimeout(() => {
      this.notifier.next();
    }, 0);
  }

  _dataEquality: boolean;
  get dataEquality(): boolean {
    return this._dataEquality;
  }
  @Input() set dataEquality(value: boolean) {
    this._dataEquality = value;
    if (!value) {
      this.getData();
    }
  }

  _colorSchemeId: number;
  get colorSchemeId(): number {
    return this._colorSchemeId;
  }
  @Input() set colorSchemeId(value: number) {
    this._colorSchemeId = value;
  }

  tickers$: Observable<any[]>;
  terminate$ = new Subject<void>();
  data: any[];
  restrictedData: boolean = false;
  notifier: Subject<void> = new Subject<void>();
  widgetType = widgetType;
  queues: any;

  constructor(private DashboardsService: DashboardService, private store: Store<State>) { }

  ngOnInit(): void {
    this.DashboardsService.getAllQueues().subscribe(d => {
      this.queues = d;
      this.getData();
    });
    if (!this.isInWizard) {
      this.store.select(getDashboardsConfigState).pipe(take(1)).subscribe(config => {
        interval((config.widgetRefreshInterval.traffic ?? 10) * 1000).pipe(takeUntil(this.terminate$)).subscribe(_ => { this.getData(); });
      });
    }
  }

  ngOnDestroy(): void {
    this.terminate$.next()
    this.terminate$.complete()
  }

  ngDoCheck(): void {
    if (!deepCheckObject(this._gridItem?.setup ?? {}, this.gridItem?.setup ?? {}) || this._gridItem?.type != this.gridItem.type) {
      this._gridItem = this.gridItem;
      this.getData();
    }
  }

  getData(): void {
    if (this.gridItem.setup.queueIds != undefined && this.gridItem.setup.traficIds != undefined) {
      if (this.gridItem.setup.queueIds.length > 0 && this.gridItem.setup.traficIds.length > 0) {
        this.tickers$ = this.DashboardsService.getTickerData(this.gridItem.setup.queueIds || [], this.gridItem.setup.traficIds || []);
        this.tickers$.subscribe((d) => {
          this.data = d.map(m => ({ ...m, timestamp: this.convertUTCDateToLocalDate(m.timestamp) }));
          this.notifier.next();
          this.restrictedData = d.length == 0;
          if (this.queues) {
            let queueIds = this.queues.map(q => q.id);
            this.restrictedDataEvent.emit(d.length > 0 && !this.gridItem.setup.queueIds.every(qId => queueIds.includes(qId)));
          }
        });
      }
    }
  }

  convertUTCDateToLocalDate(dateStr: string) {
    if (dateStr.indexOf("Z") > -1) {
      dateStr = dateStr.substring(0, dateStr.length - 1);
    }
    let date = new Date(dateStr);
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }
}
